import { authFetch } from "../utils/fetchWithRefresh";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

/* Undefined and empty values are dropped rather than sent blank: the API treats
   an empty `from` as "not supplied" and falls back to its own default window,
   but an empty `sort` or `granularity` is a 400. */
const qs = (params) => {
	const search = new URLSearchParams();
	Object.entries(params || {}).forEach(([key, value]) => {
		if (value === undefined || value === null || value === "") return;
		search.append(key, value);
	});
	const str = search.toString();
	return str ? `?${str}` : "";
};

const authHeaders = (accessToken) => ({
	"Content-Type": "application/json",
	Authorization: `Bearer ${accessToken}`,
});

const reportsRequest = {
	/* Totals, breakdowns and the daily/weekly/monthly series.
	   Staff callers are scoped to themselves by the API, whatever is passed. */
	async getSalesReport(shopId, params, accessToken) {
		const res = await authFetch(`${API_BASE}/shops/${shopId}/reports/sales${qs(params)}`, {
			method: "GET",
			headers: authHeaders(accessToken),
		});

		if (!res.ok) throw new Error(await res.text());
		return res.json();
	},

	// The client book: one row per person, with visit counts and lifetime value.
	async getCustomers(shopId, params, accessToken) {
		const res = await authFetch(`${API_BASE}/shops/${shopId}/customers${qs(params)}`, {
			method: "GET",
			headers: authHeaders(accessToken),
		});

		if (!res.ok) throw new Error(await res.text());
		return res.json();
	},

	/* customerKey is "user:<id>", "email:<address>", "manual:<slug>" or
	   "anonymous". It must be encoded — email keys carry characters that would
	   otherwise be read as part of the path. */
	async getCustomerDetail(shopId, customerKey, params, accessToken) {
		const res = await authFetch(
			`${API_BASE}/shops/${shopId}/customers/${encodeURIComponent(customerKey)}${qs(params)}`,
			{ method: "GET", headers: authHeaders(accessToken) },
		);

		if (!res.ok) throw new Error(await res.text());
		return res.json();
	},
};

export default reportsRequest;
